var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConsultancy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 113.65,
    height: 113.65,
    viewBox: "0 0 113.65 113.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56.82,
    cy: 56.82,
    r: 56.82,
    fill: "#f4a35c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.82,81.45h-46c-.34,0-.62-.28-.62-.62v-36c0-.35.28-.62.62-.62s.62.28.62.62v35.38h44.75v-35.38c0-.35.28-.62.62-.62s.62.28.62.62v36c0,.35-.28.62-.62.62Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.82,47.45c-.12,0-.25-.04-.35-.11l-25.69-17.75-25.6,17.75c-.29.2-.67.13-.87-.16-.2-.28-.13-.67.16-.87l25.95-18c.21-.15.5-.15.71,0l26.04,18c.28.2.35.59.16.87-.12.18-.32.27-.51.27Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.82,81.45H30.82c-.34,0-.62-.28-.62-.62s.28-.62.62-.62h52c.34,0,.62.28.62.62s-.28.62-.62.62Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.5,76.45c-.16,0-.32-.06-.44-.18l-5.68-5.68c-.24-.24-.24-.64,0-.88l8.9-8.9c.24-.24.64-.24.88,0,.24.24.24.64,0,.88l-8.46,8.46,4.79,4.79,8.46-8.46c.24-.24.64-.24.88,0,.24.24.24.64,0,.88l-8.9,8.9c-.12.12-.28.18-.44.18Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.92,61.03c-.16,0-.32-.06-.44-.18-.24-.24-.24-.64,0-.88l8.48-8.48-4.79-4.79-8.48,8.48c-.24.24-.64.24-.88,0-.24-.24-.24-.64,0-.88l8.92-8.92c.23-.23.65-.23.88,0l5.68,5.68c.24.24.24.64,0,.88l-8.92,8.92c-.12.12-.28.18-.44.18Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.29,75.61c-.7,0-1.36-.27-1.86-.77l-18.79-18.79c-.24-.24-.24-.64,0-.88l6.52-6.52c.23-.23.65-.23.88,0l18.79,18.79c1.02,1.02,1.02,2.69,0,3.71l-3.69,3.69c-.5.5-1.16.77-1.86.77Zm-19.32-20l18.35,18.35c.52.52,1.42.52,1.94,0l3.69-3.69c.54-.54.54-1.41,0-1.94l-18.35-18.35-5.64,5.64Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.09,56.23s-.1,0-.14-.02c-.21-.05-.38-.21-.45-.41l-3.26-9.78c-.08-.22-.02-.47.15-.64.17-.17.42-.23.64-.15l9.78,3.26c.21.07.36.24.41.45s-.01.43-.17.59l-6.52,6.52c-.12.12-.28.18-.44.18Zm-2.27-9.42l2.55,7.64,5.09-5.09-7.64-2.55Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.54,69.16c-.16,0-.32-.06-.44-.18l-15.86-15.86c-.24-.24-.24-.64,0-.88.24-.24.64-.24.88,0l15.86,15.86c.24.24.24.64,0,.88-.12.12-.28.18-.44.18Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.79,55.16c-.16,0-.32-.06-.44-.18l-1.13-1.13c-.24-.24-.25-.64,0-.88.24-.24.64-.24.88,0l1.13,1.13c.24.24.25.64,0,.88-.12.12-.28.18-.44.18Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.18,57.77c-.16,0-.32-.06-.44-.18l-1.13-1.13c-.24-.24-.24-.64,0-.88.24-.24.64-.24.88,0l1.13,1.13c.24.24.24.64,0,.88-.12.12-.28.18-.44.18Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.53,73.42c-.16,0-.32-.06-.44-.18l-1.13-1.13c-.24-.24-.25-.64,0-.88.24-.24.64-.24.88,0l1.13,1.13c.24.24.25.64,0,.88-.12.12-.28.18-.44.18Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.14,70.81c-.16,0-.32-.06-.44-.18l-1.13-1.13c-.24-.24-.25-.64,0-.88.24-.24.64-.24.88,0l1.13,1.13c.24.24.25.64,0,.88-.12.12-.28.18-.44.18Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.29,72.44c-.16,0-.32-.06-.44-.18-.24-.24-.24-.64,0-.88l6.52-6.52c.24-.24.64-.24.88,0,.24.24.24.64,0,.88l-6.52,6.52c-.12.12-.28.18-.44.18Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.75,52.23c-.16,0-.32-.06-.44-.18-.24-.24-.24-.64,0-.88l3.85-3.85c.24-.24.64-.24.88,0,.24.24.24.64,0,.88l-3.85,3.85c-.12.12-.28.18-.44.18Z",
    fill: "#dedede",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultancy);
export default __webpack_public_path__ + "static/media/consultancy.9e9820b8225557fa868bc806c7e45d44.svg";
export { ForwardRef as ReactComponent };